import { MutableRefObject } from "react";
import { SpaceObjectType } from "../../../types";

import SpaceObject from "../objects/SpaceObject";

function ObjectSetup({
  data,
  earthRef,
  defaultLabel
}: {
  data: SpaceObjectType[];
  earthRef: MutableRefObject<THREE.Object3D<THREE.Object3DEventMap>>;
  defaultLabel: string;
}) {
  return (
    <>
      {data && (
        <>
          {data.map((sat, idx) => (
            <SpaceObject key={idx} data={sat} earthRef={earthRef} defaultLabel={defaultLabel} />
          ))}
        </>
      )}
    </>
  );
}

export default ObjectSetup;
